import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USER_STATE_FEATURE_KEY, UserState } from './user-state.reducer';

const getUserState = createFeatureSelector<UserState>(USER_STATE_FEATURE_KEY);

export const isAuthenticatedSelector = createSelector(
    getUserState,
    (state) => state.isAuthenticated,
);

export const loggedInUserSelector = createSelector(
    getUserState,
    (state) => state.loggedInUser,
);

export const userRoleDataSelector = createSelector(
    getUserState,
    (state) => state.userRoleData,
);

export const userStatusSelector = createSelector(
    getUserState,
    (state) => state.userStatus,
);
